import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useEffect, useState } from 'react';

type MessageType = {
  message: string;
  type: 'success' | 'error';
};

type MessageHolderProps = {
  message: MessageType | null;
  messageVisible: boolean;
};

const MessageHolder = (props: MessageHolderProps) => {
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center p-4">
      <div
        className={`rounded-md bg-white p-2 text-center text-black transition-opacity duration-1000 ${props.messageVisible ? 'opacity-100' : 'opacity-0'}`}
      >
        {props.message ? (
          <>
            <div>
              {props.message.type == 'error' && (
                <ErrorIcon htmlColor={'red'}></ErrorIcon>
              )}
              {props.message.type == 'success' && (
                <CheckCircleIcon htmlColor={'green'}></CheckCircleIcon>
              )}
            </div>
            {props.message.message}
          </>
        ) : null}
      </div>
    </div>
  );
};

export type MessageHolderType = {
  MessageHolder: typeof MessageHolder;
  setMessage: (s: MessageType | null) => void;
  messageHolderProps: MessageHolderProps;
};

export const useCustomMessageHolder = (timeout = 2000) => {
  const [message, setMessage] = useState<MessageType | null>();
  const [messageVisible, setMessageVisible] = useState<boolean>(false);

  useEffect(() => {
    setMessageVisible(!!message);
    const handle = setTimeout(() => {
      setMessageVisible(false);
    }, timeout);
    return () => {
      clearTimeout(handle);
    };
  }, [message, setMessageVisible]);

  const messageHolderProps = {
    message: message ?? null,
    messageVisible,
  };

  return {
    MessageHolder,
    setMessage,
    messageHolderProps,
  };
};
